import {Theme, WithStyles} from '@material-ui/core';
import {bindActions, mockTheme} from '../utils/utils';
import * as React from 'react';
import {ComponentClass} from 'react';
import Grid from '@material-ui/core/Grid';
import {IStore} from '../store';
import withStyles from '@material-ui/core/styles/withStyles';
import {connect} from 'react-redux';
import {JSONSchema6} from 'json-schema';
import EnhancedSchemaForm from '../components/schemaForm';
import Button from '@material-ui/core/Button';
import {ISubmitEvent} from 'react-jsonschema-form';
import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
import {IFCMStore, MessageActions} from '../store/fcm';
import Paper from '@material-ui/core/Paper';


const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    },
    disableIcon: {
        color: orange[900]
    },
    editIcon: {
        color: blue[500]
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface MessagesProps extends WithStyles<keyof typeof classesType> {
    actions: MessageActions;
    data: IFCMStore;
}

const newMessageSchema: JSONSchema6 = {
    title: 'Enviar mensaje',
    type: 'object',
    required: ['type', 'title', 'message'],
    properties: {
        type: {
            type: 'string', title: 'Tipo de envio', "anyOf":
                [
                    {"type": "string", "enum": ['topic'], "title": "A un grupo"}
                ],
            default: 'DELIVERY'
        },
        title: {type: 'string', title: 'Titulo', minLength: 5},
        message: {type: 'string', title: 'Mensaje', minLength: 5}
    },
    dependencies: {
        type: {
            oneOf: [{
                properties: {
                    type: {enum: ['topic']},
                    topicName: {
                        type: 'string', title: 'Grupo', anyOf:
                            [
                                {"type": "string", "enum": ['driver'], "title": "Usuario"},
                                {"type": "string", "enum": ['user'], "title": "Usuarios"}
                            ]
                    }
                },
                required: ['topicName']
            }]
        }
    }
};

class Messagess extends React.Component<MessagesProps, { data: any }> {


    static getDefaultEntity() {
        return {title: '', message: '', type: 'topic', topicName: 'driver'};
    }

    constructor(props: MessagesProps) {
        super(props);
        this.state = {data: Messagess.getDefaultEntity()};

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e: ISubmitEvent<any>) {
        console.log(e.formData);
        this.props.actions.save(e.formData);
        this.setState({
            data: Messagess.getDefaultEntity()
        })
    }


    render() {

        return (
            <Paper elevation={11} style={{padding: 10}}>
                <Grid container spacing={24}>
                    <Grid item sm={12} md={12}>

                        <EnhancedSchemaForm
                            schema={newMessageSchema}
                            formData={this.state.data}
                            onSubmit={this.handleSubmit}
                        >
                            <div>
                                <Button variant='contained' color='primary' type='submit'
                                        disabled={this.props.data.send.fetching}>
                                    Aceptar
                                </Button>
                            </div>
                        </EnhancedSchemaForm>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: MessagesProps) => ({
    ...ownProps,
    data: state.fcm
});


const styled = withStyles(styles as any)(Messagess);
const connected = connect(mapStateToProps, bindActions(MessageActions))(styled);

export default connected as ComponentClass<Partial<MessagesProps>>;




// WEBPACK FOOTER //
// ./src/pages/MessagesPage.tsx